import React, { useContext } from 'react'
import Icon from './Icon'
import { NodeArray, truncateLink, getAffiliateFeeString, Variations } from './Amazon'
import Clipboard from 'react-clipboard.js'
import provider from '../modules/provider'
import { ResourcesContext } from './ArticleResourcesContent'
import { appStateContext } from '../App'
import ViewMore from './ViewMore'
import { ProductImage } from './Image'

const getEditorialReviews = (props) => {
    let EditorialReviews = props.EditorialReviews && props.EditorialReviews.EditorialReview
    EditorialReviews = (EditorialReviews && !Array.isArray(EditorialReviews) && [EditorialReviews]) || EditorialReviews
    return EditorialReviews
}

export const Features = (props) => {
    let FeatureArray = props.ItemAttributes && props.ItemAttributes.Feature
    FeatureArray = (FeatureArray && !Array.isArray(FeatureArray) && [FeatureArray]) || FeatureArray
    return (
        (FeatureArray && (
            <>
                <strong>Features</strong>
                <ViewMore more="View features">
                    <ul className="mb-0">
                        {FeatureArray.map((f, index) => (
                            <li key={`feature-${index}`}>{f}</li>
                        ))}
                    </ul>
                </ViewMore>
            </>
        )) ||
        null
    )
}

export const EditorialReview = (props) => {
    return (
        <>
            <strong className="d-block mt-2">Description</strong>
            <ViewMore more="Read description">
                <div dangerouslySetInnerHTML={{ __html: props.Content }} />
            </ViewMore>
        </>
    )
}

const AmazonProductRow = (props) => {
    const editorialReviews = getEditorialReviews(props)
    const resourcesContext = useContext(ResourcesContext)
    const appState = useContext(appStateContext)

    const { id, label, image_array, node_array, offer, available } = props

    // Get the product in other countries, check if it exists - not ready yet as no account has been validated yet (3 sales...)
    // useEffect(() => {
    //     get('provider/amazon/product_details?endpoint=UK')
    // }, [props.ASIN])

    return (
        <tr key={`product-${id}`} className="pb-3 w-100">
            <td className="row px-0">
                <div className={(props.reviews && 'col-9') || 'col-12'}>
                    {(node_array && (
                        <small className="d-block">
                            <small>
                                <NodeArray node_array={node_array} location_search={props.location_search} />
                            </small>
                        </small>
                    )) ||
                        null}
                    <strong className="d-block">
                        {(props.index && <span>{props.index} - </span>) || null}
                        {label}
                    </strong>
                    <div>
                        {(offer && <span className="badge badge-info mr-1">{offer.display_amount}</span>) || null}
                        {(props.VariationSummary && props.VariationSummary.LowestPrice && (
                            <span className="badge badge-info mr-1">{props.VariationSummary.LowestPrice.FormattedPrice}</span>
                        )) ||
                            null}

                        <span className={'badge badge-' + ((available && 'info') || 'danger') + ' mr-1'}>{(available && 'Available') || 'Unavailable'}</span>

                        <span className="badge badge-info mr-1">
                            {(props.BrowseNodes &&
                                getAffiliateFeeString(
                                    props.BrowseNodes,
                                    (props.OfferSummary && props.OfferSummary.LowestNewPrice) || (props.VariationSummary && props.VariationSummary.LowestPrice)
                                )) ||
                                null}
                        </span>
                        {(props.sales_rank && (
                            <span className="badge badge-dark mr-1">
                                <Icon name="salesrank" /> {props.sales_rank}
                            </span>
                        )) ||
                            null}
                        <a href={truncateLink(props.detail_page_url)} className="badge badge-secondary mr-1 pointer" target="_blank" rel="noopener noreferrer">
                            <i className="fal fa-external-link-alt" />
                        </a>
                        {(props.detail_page_url && !props.detail_page_url.indexOf('tag=null') && (
                            <Clipboard className="badge badge-secondary mr-1 pointer" data-clipboard-text={props.detail_page_url}>
                                <i className="fal fa-link" />
                            </Clipboard>
                        )) ||
                            null}
                        {(resourcesContext && resourcesContext.addProduct && appState.state.resource_article_id && (
                            <span
                                className="badge badge-secondary mr-1 pointer"
                                onClick={() =>
                                    resourcesContext.addProduct({
                                        providerProductId: { ASIN: props.ASIN },
                                        origin_: props.origin,
                                        originalUrl_: props.originalUrl,
                                        displayUrl_: props.displayUrl,
                                        locale: props.locale,
                                        tracking_id: props.tracking_id,
                                    })
                                }
                            >
                                <Icon name="angle-double-right" />
                            </span>
                        )) ||
                            null}
                        <small className="text-muted">{props.ASIN}</small>
                    </div>
                    {(props.description &&
                        editorialReviews &&
                        editorialReviews.map((e, index) => (
                            <small key={`er-${index}`} className="d-block">
                                <EditorialReview {...e} />
                            </small>
                        ))) ||
                        null}
                    {(props.ItemAttributes && props.ItemAttributes.Feature && (
                        <small>
                            <Features {...props} />
                        </small>
                    )) ||
                        null}
                    <ul className="list-unstyled mt-2">
                        {image_array.map((image, image_index) => (
                            <li
                                key={`${props.id}-${image_index}`}
                                className={
                                    'd-inline-block amazon-selector-image mr-2' +
                                    ((props.ItemClickCallback && ' pointer') || '') +
                                    ((props.currentBench &&
                                        props.currentBench.find((product) => product.image_url === image.url) &&
                                        ' amazon-selector-selected-image') ||
                                        '')
                                }
                            >
                                <div className="d-flex justify-content-center position-relative">
                                    <React.Fragment>
                                        {(props.currentBench && props.currentBench.find((product) => product.image_url === image.url) && (
                                            <Icon name="check" className={'icon-check '} key={'selected-' + image_index} />
                                        )) ||
                                            null}
                                    </React.Fragment>

                                    <img
                                        src={image.url}
                                        alt={props.label}
                                        className="align-self-center"
                                        onClick={(props.ItemClickCallback && (() => props.ItemClickCallback(props, image.url))) || undefined}
                                    />
                                    {(props.onImageAction && props.onImageAction(image)) || null}
                                </div>
                            </li>
                        ))}

                        {/* {props.ImageSets &&
                            props.ImageSets.ImageSet &&
                            getImageSet(props.ImageSets.ImageSet).map((image, image_index) => (
                                <li
                                    key={`${props.ASIN}-${image.MediumImage.URL}-${image_index}`}
                                    className={'d-inline-block amazon-selector-image mr-2' + ((props.ItemClickCallback && ' pointer') || '') + ((props.currentBench && props.currentBench.find(product => product.image_url === image.LargeImage.URL) && ' amazon-selector-selected-image') || '')}>
                                    <div className='d-flex justify-content-center'>
                                        <React.Fragment>{(props.currentBench && props.currentBench.find(product => product.image_url === image.LargeImage.URL) && <Icon name='check' className={'icon-check '} key={'selected-' + image_index} />) || null}</React.Fragment>
                                        <img src={image.MediumImage.URL} alt='' className='img-fluid align-self-center' onClick={(props.ItemClickCallback && (() => props.ItemClickCallback(props, image.LargeImage.URL))) || undefined} />
                                    </div>
                                </li>
                            ))} */}
                    </ul>
                    {(props.Variations && (
                        <Variations
                            {...props.Variations}
                            currentBench={props.currentBench || undefined}
                            ItemClickCallback={(props.ItemClickCallback && ((image_url) => props.ItemClickCallback(props, image_url))) || undefined}
                        />
                    )) ||
                        null}
                </div>
                {(props.reviews && (
                    <div className="col-3 text-right">
                        {props.CustomerReviews && props.CustomerReviews.IFrameURL && (
                            <iframe
                                className="amazon-selector-reviews-container"
                                title={props.CustomerReviews.IFrameURL}
                                src={props.CustomerReviews.IFrameURL}
                            />
                        )}
                        {props.append || null}
                    </div>
                )) ||
                    null}
            </td>
        </tr>
    )
}

export default AmazonProductRow
